<template>
  <div class="goodslistall" v-if="goodslist.length > 0">
    <div class="goodsshow">
      <div v-for="(goods, index) in goodslist" :key="index">
        <user-collection-info-item
          :iconon="iconon"
          :iconoff="iconoff"
          :goods="goods"
          :index="(index + 1) % 4"
          @editgoods="editgoods"
          :itemright="(index + 1) % 4 == 0 ? '0' : itemright"
          :itemwidth="itemwidth"
          :itemtop="itemtop"
        />
      </div>
      <div class="clear"></div>
    </div>
    <div class="pageshow" v-if="showpage && total > pagesize">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :current-page.sync="currentPage"
        :page-size="pagesize"
        background
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
  <el-empty
    v-else
    :description="description"
    :image="emptyimg"
    :image-size="imagesize"
  ></el-empty>
</template>

<script>
import UserCollectionInfoItem from "./UserCollectionInfoItem.vue";
import { mapGetters } from "vuex";
import { Message } from "element-ui";
export default {
  data() {
    return {
      goodslist: {},
      total: 0,
      currentPage: 1
    };
  },
  props: {
    pagesize: {
      type: Number,
      default: 1
    },
    url: {
      type: String,
      default: "/user_collection"
    },
    iconon: {
      type: String,
      default: "el-icon-delete"
    },
    iconoff: {
      type: String,
      default: "el-icon-delete"
    },
    showpage: {
      type: Boolean,
      default: true
    },
    orderby: {
      type: Number,
      default: 0
    },
    description: {
      type: String,
      default: "没有找到相应产品"
    },
    emptyimg: {
      type: String,
      default: "/static/404/goods.png"
    },
    imagesize: {
      type: Number,
      default: 328
    },
    itemright: {
      type: String,
      default: "29px"
    },
    itemwidth: {
      type: String,
      default: "213px"
    },
    itemtop: {
      type: String,
      default: "33px"
    }
  },
  components: { UserCollectionInfoItem },
  methods: {
    getgoodslist() {
      //重新获取数据
      this.getGoodsWhere.cid = this.$route.params.pid;
      this.getGoodsWhere.sort = this.orderby;
      this.getGoodsWhere.currentPage = this.currentPage;
      this.getGoodsWhere.pagesize = this.pagesize;
      //console.log("我开始执行了le")
      //const res = await this.$http.post(this.url,this.getGoodsWhere)
      var where = {};
      where.params = {};
      where.params.cid = this.getGoodsWhere.cid;
      where.params.cid2 = this.getGoodsWhere.classid;
      if (this.getGoodsWhere.sonclassid) {
        where.params.cid3 = this.getGoodsWhere.sonclassid;
      }

      where.params.sort = this.getGoodsWhere.sort;
      where.params.options = this.getGoodsWhere.attr;
      where.params.pageIndex = this.getGoodsWhere.currentPage;
      where.params.uid = this.UserId;
      this.$api.goods.getgoodslistbyclass(where).then(res => {
        //console.log(res.data.datas);
        this.goodslist = res.data.datas.data;
        this.total = res.data.datas.total;
      });
    },
    handleSizeChange() {},
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getgoodslist();
    },
    editgoods(goodsid) {
      //console.log("我执行了")
      this.$emit("editgoods", goodsid);
    },
    deletegoods(goodsid) {
      //删除我的收藏
      var index = this.goodslist.findIndex(item => {
        if (item.id == goodsid) {
          return true;
        }
      });
      this.goodslist.splice(index, 1);
    },
    doeditgoods(goodsid) {
      //收藏
      var index = this.goodslist.findIndex(item => {
        if (item.id == goodsid) {
          return true;
        }
      });
      this.$api.goods
        .getStoreAdd(goodsid, (this.goodslist[index].store + 1) % 2)
        .then(res => {
          if (res.data.errno == 0) {
            if (this.goodslist[index].store == 1) {
              this.$set(this.goodslist[index], "store", 0);
              this.$FUnitls.showInfo("取消收藏", "info");
            } else {
              this.$set(this.goodslist[index], "store", 1);
              this.$FUnitls.showInfo("已收藏", "info");
            }
            // var options={
            //   message:"收藏成功",
            // }
            // Message.success(options)
          } else {
            var options = {
              message: res.data.errmsg
            };
            Message.error(options);
          }
        });
      //console.log(index)
    }
  },
  watch: {
    getGoodsWhere(val) {
      this.getgoodslist();
      this.currentPage = 1;
    },
    orderby() {
      this.getgoodslist();
      this.currentPage = 1;
    }
  },
  mounted() {
    if (this.$route.params.classid < 1) {
      this.getgoodslist();
    }
  },
  computed: {
    ...mapGetters(["getGoodsWhere", "UserId"])
  }
};
</script>

<style scoped>
.goodslist {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserCollectionInfo.vue